<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  currentAmount: number;
  threshold: number;
}>();

const remaining = computed(() => Math.max(props.threshold - props.currentAmount, 0));
const progress = computed(() => Math.min((props.currentAmount / props.threshold) * 100, 100));
const isFree = computed(() => remaining.value === 0);
</script>

<template>
  <div class="bg-yellow-50 rounded-lg p-4 flex flex-col gap-2">
    <p class="font-montserrat text-xs text-brown-600 font-medium leading-relaxed">
      <template v-if="isFree">
        Dopravu máte <strong class="font-bold">zdarma!</strong>
      </template>
      <template v-else>
        Nakupte ještě za <strong class="font-bold">{{ remaining.toLocaleString('cs-CZ') }} Kč</strong> a dopravu máte <strong class="font-bold">zdarma!</strong>
      </template>
    </p>
    <div class="h-2 rounded-full bg-yellow-100 overflow-hidden">
      <div
        class="h-full rounded-full bg-yellow-400 transition-all duration-300"
        :style="{ width: `${progress}%` }"
      />
    </div>
  </div>
</template>
